import {memo} from "react";
import moment from "moment";
import {Tooltip, Whisper} from "rsuite";
import {RiShieldCheckIcon, RiToolsIcon} from "../../../models/Icons.model";
import {DeviceIconProps} from "./DeviceIcon.model";

const getIconPath = (fileName: string) => `${process.env.PUBLIC_URL}/${fileName}`;

const DeviceIcons = memo(({ deviceData, className = "", showServiceAlerts = false }: DeviceIconProps) => {
  const warrantyExpirationDate = deviceData?.warrantyExpirationDate;
  const nextMaintenanceDate = deviceData?.nextMaintenanceDate;
  const warrantyDate = moment(warrantyExpirationDate, ["YYYY-MM-DD", moment.ISO_8601], true);
  const maintenanceDate = moment(nextMaintenanceDate, ["YYYY-MM-DD", moment.ISO_8601], true);
  const hasWarranty = Boolean(warrantyExpirationDate) && warrantyDate.isValid();
  const isWarrantyActive = hasWarranty && warrantyDate.startOf("day").isSameOrAfter(moment().startOf("day"));
  const needsMaintenance = Boolean(nextMaintenanceDate)
    && maintenanceDate.isValid()
    && maintenanceDate.startOf("day").isSameOrBefore(moment().startOf("day"));

  return (
    <>
      <div className={className}>
        {deviceData?.icons?.hasSimCard
          ? <img src={getIconPath("hasSimCard.svg")} alt="sim" className="header-icon"/>
          : <img src={getIconPath("noSimCard.svg")} alt="sim" className="header-icon"/>}
        {deviceData?.icons?.hasBigLineDevices
          ? <img src={getIconPath("hasBigLineDevices.svg")} alt="big line" className="header-icon"/>
          : <img src={getIconPath("noBigLineDevices.svg")} alt="big line" className="header-icon"/>}
        {deviceData?.icons?.hasUsers
          ? <img src={getIconPath("hasUsers.svg")} alt="users" className="header-icon"/>
          : <img src={getIconPath("noUsers.svg")} alt="users" className="header-icon"/>}
        {deviceData?.icons?.isEthernetConnected
          ? <img src={getIconPath("isEthernetConnected.svg")} alt="ethernet" className="header-icon"/>
          : <img src={getIconPath("noEthernet.svg")} alt="ethernet" className="header-icon"/>}
        {deviceData?.icons?.isWiFiConnected
          ? <img src={getIconPath("isWiFiConnected.svg")} alt="wifi" className="header-icon"/>
          : <img src={getIconPath("noWiFi.svg")} alt="wifi" className="header-icon"/>}
        {showServiceAlerts && hasWarranty && (
          <Whisper
            placement="bottom"
            speaker={<Tooltip>Гарантия действует до {warrantyDate.format("DD.MM.YYYY")}</Tooltip>}
          >
            <span
              className={`header-device-alert header-device-alert--warranty ${
                isWarrantyActive
                  ? "header-device-alert--warranty-active"
                  : "header-device-alert--warranty-expired"
              }`}
              aria-label="Гарантия действует"
            >
              <RiShieldCheckIcon />
            </span>
          </Whisper>
        )}
        {showServiceAlerts && needsMaintenance && (
          <Whisper
            placement="bottom"
            speaker={<Tooltip>Пройдите ТО. Обратитесь в сервисный центр</Tooltip>}
          >
            <span className="header-device-alert header-device-alert--maintenance" aria-label="Требуется ТО">
              <RiToolsIcon />
            </span>
          </Whisper>
        )}
      </div>
    </>
  );
});

export default DeviceIcons;
